import React from 'react';
import { SET_MARKETING_HAS_BROCHURE, SET_PROPERTY_FIELDS } from "../../types";
import { setAlert } from "../alert";
import axios from "axios";
import { setUnmarketableFlag } from "./properties";
import { setModalData, showModal } from "@redux-action/reduxConfirmModal";

/**
 * @name    setMarketingPriceHistory
 * @returns {function(...[*]=)}
 */
export const setMarketingPriceHistory = () => async(dispatch, getState) => {
    try {
        const { properties: { propertyFields } } = getState();
        const { financial_list_price_history } = propertyFields;
        let newPropertyFields = { ...propertyFields };

        let Info = [];
        if (financial_list_price_history) {
            Info = [...JSON.parse(financial_list_price_history)];
        }
        console.debug(Info);

        if (Info.length === 0) {
            //	Set value to default if List is empty

            newPropertyFields = {
                ...newPropertyFields,
                financial_current_list_price: 0,
                financial_current_list_price_date: "",
                financial_initial_list_price: 0
            };
        }
        else if (Info.length === 1) {
            //	Set Price the same for initial and current because Info has one item
            //	Any new item push to the array will be last; Therefor, will pop out the last item of the array
            const { Date, Price } = Info[0];
            newPropertyFields = {
                ...newPropertyFields,
                financial_current_list_price: Price,
                financial_current_list_price_date: Date,
                financial_initial_list_price: Price
            };
        }
        else if (Info.length >= 2) {
            //	Get the near last item of the array for initial price
            //	Any new item push to the array will be last; Therefor, will pop out the last item of the array
            const { Date, Price } = Info.shift();
            const { Price: originalListPrice } = Info.pop();

            newPropertyFields = {
                ...newPropertyFields,
                financial_current_list_price: Price,
                financial_current_list_price_date: Date,
                financial_initial_list_price: originalListPrice
            };
        }
        dispatch({
            type: SET_PROPERTY_FIELDS,
            payload: newPropertyFields
        });
    }
    catch (error) {
        dispatch(setAlert(error.message, "error"));
    }
};

/**
 * @name    setMarketingOfferHistory
 * @returns {function(...[*]=)}
 */
export const setMarketingOfferHistory = () => async(dispatch, getState) => {
    try {
        const { properties: { propertyFields } } = getState();
        const { marketing_offer_history } = propertyFields;
        let Info = [];
        if (marketing_offer_history) {
            Info = JSON.parse(marketing_offer_history);
        }

        dispatch({
            type: SET_PROPERTY_FIELDS,
            payload: {
                ...propertyFields,
                marketing_number_of_offers: Info.length
            }
        });
    }
    catch (error) {
        dispatch(setAlert(error.message, "error"));
    }
};

/**
 * @name    setMarketingHasBrochure
 * @param   component
 * @param   verb
 * @param   id
 * @returns {function(...[*]=)}
 */

export const setMarketingHasBrochure = (
    component,
    verb,
    id
) => async dispatch => {
    try {
        const response = await axios.post(
            `/${component}/${verb}/${id}/hasFile?path=Marketing&file=brochure.pdf`
        );
        dispatch({
            type: SET_MARKETING_HAS_BROCHURE,
            payload: response.data
        });
    }
    catch (error) {
        dispatch(setAlert(error.message, "error"));
    }
};

/**
 * @name    deleteMarketingBrochure
 * @param   component
 * @param   verb
 * @param   id
 * @returns {function(...[*]=)}
 */

export const deleteMarketingBrochure = (
    component,
    verb,
    id
) => async dispatch => {
    try {
        await axios.delete(
            `/${component}/${verb}/${id}/delete/brochure`
        );

        //  DESC: verify with backend if file is deleted.
        await dispatch(setMarketingHasBrochure(component, verb, id));

        dispatch(setAlert("Brochure is deleted.", "success"));
    }
    catch (error) {
        dispatch(setAlert(error.message, "error"));
    }
};

/**
 * @name    uploadMarketingBrochure
 * @param   payload
 * @returns {function(...[*]=)}
 * @description
 * This method is being used by MarketingButtonGroup component
 * This will handle permission check, file check, and uploading to ownCloud.
 */

export const uploadMarketingBrochure = payload => async(
    dispatch,
    getState
) => {
    try {
    //  TODO: Make this happens
    //  DESC: check for upload_brochure permission
    //  DESC: throw error if use doesn't now have permission
    //  DESC: why throw error? because action button already been filtered out at setContextMenu
    //  DESC: if user can trigger the action which mean it is unexpected behavior
    //  DESC: result in stop the action and throw error
    // const isPermitted = await dispatch(CanI('upload_brochure'));
    // if (!isPermitted) {
    //     throw new Error('Not Permitted');
    // }

        //	DESC: Checking for file extension. Maretking brochure only accept *.pdf. Therefore, We'll reject everything else.

        if (payload.type !== "application/pdf") {
            throw new TypeError("Brochure only accepts *.PDF extension!");
        }

        //  DESC: get property id from state
        const { properties: { propertyFields: { id } } } = getState();

        //  DESC: Request config - content type has to be 'multipart/form-data' to be able to pass FormData with the request
        const configs = { headers: { "content-type": "multipart/form-data" } };

        //  DESC: define a new FormData instance - append file and path to the form
        //  ATTN: slash `/` before path is a requirement.
        let formData = new FormData();
        formData.append("file", payload);
        formData.append("path", "/Marketing");

        //  DESC: make a post request to back end with file attached inside FormData
        await axios.post(
            `/properties/edit/${id}/upload/brochure`,
            formData,
            configs
        );
        //  DESC: verify with backend if file is uploaded.
        await dispatch(setMarketingHasBrochure("properties", "edit", id));

        dispatch(setAlert("Brochure is Uploaded", "success"));

        return { status: 200 };
    }
    catch (error) {
        dispatch(setAlert(error.message, "error"));
        return false;
    }
};

/**
 * @name    updateMarketing
 * @param   event
 * @returns {function(...[*]=)}
 */

export const updateMarketing = event => async(dispatch, getState) => {
    event.persist && event.persist();
    const { properties: { propertyFields, propertyData: { status_secondary } }, reduxConfirmModal: { hasConfirm } } = getState();
    const { name, value } = event.target;
    const clonedEvent = {
        name: event.target.name,
        value: event.target.value
    };
    const newPropertyFields = {
        ...propertyFields,
        [name]: value
    };

    //  DESC: field's name
    try {
    // PRE_UPDATE
        switch (name) {
            case "marketing_published":
                //  dispatch show  generic modal
                if (parseInt(value) === 1) {
                // Is this property marketable?
                    let hasMarketableStatus =
                            propertyFields.status_primary === "A";
                    let hasBrokersId =
                            propertyFields.marketing_brokers_id !== null;
                    let hasCoordinates = propertyFields.coordinates !== null;

                    let inStatusSecondary = [10, 11, 12, 14].includes(
                        parseInt(propertyFields.status_secondary)
                    );

                    let marketable =
                            hasMarketableStatus &&
                            hasBrokersId &&
                            hasCoordinates &&
                            inStatusSecondary;

                    const messageBody = () => {

                        const statusSecondary = status_secondary.filter(status => {
                            return [10, 11, 12, 14].includes(parseInt(status.id));
                        });
                        return (
                            <div>
                                {! marketable && (
                                    <p>This asset is missing the following requirements:</p>
                                ) || (
                                    <p>This asset meets all the marketability requirements!</p>
                                )}
                                <ul>
                                    <li>
                                            Status is Active {hasMarketableStatus ?
                                            <i className="fas fa-check text-success" /> :
                                            <i className="fas fa-times text-danger" />}
                                    </li>
                                    <li>
                                           Requires a Brokers ID {hasBrokersId ?
                                            <i className="fas fa-check text-success" /> :
                                            <i className="fas fa-times text-danger" />}
                                    </li>
                                    <li>
                                            Coordinates are set {
                                            hasCoordinates ?
                                                <i className="fas fa-check text-success" /> :
                                                <i className="fas fa-times text-danger" />}
                                    </li>
                                    <li>
                                            Status Summary must be one of these following:

                                        {inStatusSecondary ?
                                            <i className="fas fa-check text-success" /> :
                                            <i className="fas fa-times text-danger" />}
                                        <ul>
                                            {statusSecondary.map(status => {
                                                return (
                                                    <li key={status.id}>
                                                        {status.description}
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    </li>
                                </ul>

                                {marketable && (
                                    <p>Are you sure you would like to publish to Real Look?</p>
                                )}
                            </div>
                        );
                    };

                    const handleOnConfirm = (payload) => {
                        dispatch({
                            type: SET_PROPERTY_FIELDS,
                            payload: {
                                ...newPropertyFields,
                                [payload.name]: payload.value
                            }
                        });
                    };
                    if (!marketable || !hasConfirm) {
                        dispatch(showModal(true, 'Marketability Check'));

                        return dispatch(
                            setModalData({
                                title: 'Marketability Check',
                                body: messageBody,
                                onConfirm: marketable && handleOnConfirm,
                                clonedEvent,
                                closeText: marketable ? 'Cancel' : 'Close'
                            })
                        );
                    }

                }
                break;

            default:
                break;
        }

        await dispatch({
            type: SET_PROPERTY_FIELDS,
            payload: newPropertyFields
        });
        console.debug(name);

        //	POST_UPDATE
        switch (name) {
            case "marketing_unmarketable_end_date":
            case "marketing_unmarketable_start_date":
                dispatch(setUnmarketableFlag());
                break;
            case "financial_list_price_history":
                dispatch(setMarketingPriceHistory());
                break;
            case "marketing_offer_history":
                dispatch(setMarketingOfferHistory());
                break;
            default:
                break;
        }
    }
    catch (error) {
        dispatch(setAlert(error.message, "error"));
    }
};
